import Raven from 'raven-js';
import vex from 'vex-js';
import vexDialog from 'vex-dialog';

vex.registerPlugin(vexDialog);

const TOAST_CLASS_NAME = 'RSGToast';
const TOAST_DEFAULT_DURATION = 3000;

class Toast {
  constructor() {
    this.toastTimer = null;
    $(() => this.init());
  }

  init() {
    $('body')
      .on('click', '.vex .vex-content a', () => {
        this.close();
      })
      .on({
        // 인스턴트 메세지 자동 닫기 마우스 오버할 때 지연되도록
        mouseover: () => {
          clearTimeout(this.toastTimer);
        },
        mouseout: () => {
          if (Object.keys(vex.getAll()).length > 0) {
            this.setTimer(TOAST_DEFAULT_DURATION);
          }
        },
      }, `.vex.${TOAST_CLASS_NAME} .vex-content`);

    // REACT + TS에 TOAST 추가 전까지 books toast 사용할 수 있도록 이벤트 추가
    window.addEventListener('toast', event => {
      const {
        message,
        durationMs,
        callback,
        type,
      } = event.detail;
      this.show(message, durationMs, callback, type);
    });
  }

  setTimer(durationMs, closeCallback = () => ({})) {
    this.toastTimer = setTimeout(() => {
      this.close();
      closeCallback();
    }, durationMs);
  }

  /**
   * @param {string|Object} message
   * @param {string} [message.text]
   * @param {string} [message.linkUrl]
   * @param {string} [message.linkTitle]
   * @param {boolean} [message.showArrowIcon]
   * @param {boolean} [message.button]
   * @param {number} durationMs
   * @param {function} callback
   * @param {string} status
   * @param {function} closeCallback
   */
  show(message, durationMs = TOAST_DEFAULT_DURATION, callback = (() => {}), status = '', closeCallback = () => ({})) {
    const $body = $('body');
    if (!$body || $body.length === 0) {
      Raven.captureMessage('select body with jQuery is undefined when toast.show()');
      return;
    }

    let fullMessage;
    if (typeof message === 'string') {
      fullMessage = message;
    } else if (message.linkUrl) {
      const showArrowIcon = message.showArrowIcon || true;
      const arrowIcon = showArrowIcon ? '<span class="toast_arrow_icon"></span>' : '';
      fullMessage = `<span class="toast_text">${message.text}</span><a href="${message.linkUrl}">${message.linkTitle}${arrowIcon}</a>`;
    } else if (message.button) {
      fullMessage = `<span class="toast_text">${message.text}</span>${message.button}`;
    } else {
      fullMessage = message.text;
    }

    this.close();
    $body.addClass(`${TOAST_CLASS_NAME}-open`);

    vex.dialog.alert({
      className: TOAST_CLASS_NAME,
      showCloseButton: true,
      unsafeMessage: fullMessage,
      contentClassName: status,
      afterOpen: () => {
        this.setTimer(durationMs, closeCallback);
      },
      callback,
    });
  }

  /**
   * @param {string|Object} message
   * @param {string} [message.text]
   * @param {string} [message.linkUrl]
   * @param {string} [message.linkTitle]
   * @param {boolean} [message.showArrowIcon]
   * @param {boolean} [message.button]
   * @param {number} [durationMs]
   * @param {function} [callback]
   * @param {function} [closeCallback]
   */
  success(message, durationMs, callback, closeCallback) {
    this.show(message, durationMs, callback, 'success', closeCallback);
  }

  /**
   * @param {string|Object} message
   * @param {string} [message.text]
   * @param {string} [message.linkUrl]
   * @param {string} [message.linkTitle]
   * @param {boolean} [message.showArrowIcon]
   * @param {boolean} [message.button]
   * @param {number} [durationMs]
   * @param {function} [callback]
   */
  fail(message, durationMs, callback) {
    this.show(message, durationMs, callback, 'fail');
  }

  confirm(message, yesText, noText, callback) {
    vex.dialog.confirm({
      message,
      className: 'RSGDialog',
      callback,
      buttons: [
        {
          text: yesText,
          type: 'button',
          className: 'vex-dialog-button-primary',
          click: function yesClick() {
            this.value = true;
            this.close();
          },
        },
        {
          text: noText,
          type: 'button',
          className: 'vex-dialog-button-secondary',
          click: function yesClick() {
            this.value = false;
            this.close();
          },
        },
      ],
    });
  }

  close() {
    const $body = $('body');
    if (!$body || $body.length === 0) {
      Raven.captureMessage('select body with jQuery is undefined when toast.close()');
      return;
    }

    $body.removeClass(`${TOAST_CLASS_NAME}-open vex-open`);
    if (Object.keys(vex.getAll()).length > 0) {
      vex.closeAll();
    }
    clearTimeout(this.toastTimer);
  }
}

const toast = new Toast();

export default toast;



// WEBPACK FOOTER //
// ./util/toast.js